import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-office-representative-district-wise',
  // standalone: true,
  // imports: [],
  templateUrl: './office-representative-district-wise.component.html',
  styleUrl: './office-representative-district-wise.component.scss'
})
export class OfficeRepresentativeDistrictWiseComponent  implements OnInit{
    startDate = '';
     country;
     state;
     endDate = '';
     rep_name;
     rep_taluka;
     today = new Date();
     rojmelData;
     isLoading: boolean = false;
     subTypesName = [
       { name: 'वार्षिक', isVisible: false },
       { name: 'त्रैवार्षिक', isVisible: false },
       { name: 'पंचवार्षिक', isVisible: false },
       { name: 'रा.स्व.संघ ग्रंथ', isVisible: false },
       // { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
       // { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
       // { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
       // { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
       // { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
       // { name: 'हिंदुत्व 1', isVisible: false },
       // { name: 'हिंदुत्व 2', isVisible: false },
       // { name: 'आजीव', isVisible: false },
       // { name: 'अनामत', isVisible: false },
     ];
     totalth = 0;
     finalData = [];
     datewisedata: any;
   
     constructor(
       private service: DigisubservicesService,
       private dialogRef: MatDialogRef<OfficeRepresentativeDistrictWiseComponent>,
       @Inject(MAT_DIALOG_DATA) public data: any
     ) { }
   
     ngOnInit(): void {
       console.log(this.data, "thid data")
       this.isLoading = true;
       this.startDate = this.data['startDate'];
       this.endDate = this.data['endDate'];
       this.rep_name = this.data['rep_name'];
         this.rep_taluka = this.data['rep_taluka'];
           this.country = this.data['country'];
             this.state = this.data['state'];
       // console.log(this.startDate, this.endDate);
       // console.log(this.data['data']);
       this.datewisedata = this.data['dataset'];
   
       console.log(this.datewisedata, "new data set")
       this.rojmelData = this.data['data'];
       // .filter((a) => {
       //   return (
       //     new Date(a['entry_date']) >= new Date(this.startDate) &&
       //     new Date(a['entry_date']) <= new Date(this.endDate)
       //   );
       // });
       // console.log(this.rojmelData);
   
       let data = this.uniqueData(this.rojmelData, (a) => a.subscription_type);
   
       for (let i = 0; i < Object.keys(data).length; i++) {
         let flag = false;
         for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
           if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
             this.subTypesName[j]['isVisible'] = true;
             flag = true;
             break;
           }
         }
         if (!flag) {
          
           this.subTypesName.push({
             name: data[i]['subscription_type'],
             isVisible: true,
           });
           // }
         }
       }
   
     
       this.totalth = this.subTypesName.length * 3 + 9;
   
       this.setData();
     }
     countryNameNew: any
     stateNameNew: any
    



























// setData() {
//   this.finalData = [];
//   this.isLoading = true;

//   const finalTotal: any = {
//     name: 'एकूण',
//     'वर्गणी दार संख्या': 0,
//     नवीन: 0,
//     नूतनीकरण: 0,
//     'नूतनी-बाकी': 0,
//     'रक्कम': 0,
//   };

//   this.subTypesName.forEach(sub => {
//     if (sub.isVisible) {
//       const key = this.getKey(sub.name);
//       ['नवीन', 'नूतनीकरण', 'नूतनी-बाकी', 'एकूण'].forEach(suffix => {
//         finalTotal[`${key}_${suffix}`] = 0;
//       });
//     }
//   });

//   const countryMap = new Map<string, Map<string, Map<string, any[]>>>();

//   for (const rec of this.rojmelData) {
//     const country = rec.country || 'UNKNOWN';
//     const state = rec.state || 'UNKNOWN';
//     const officeRep = rec.office_rep_name || 'UNKNOWN';

//     if (!countryMap.has(country)) countryMap.set(country, new Map());
//     const stateMap = countryMap.get(country)!;

//     if (!stateMap.has(state)) stateMap.set(state, new Map());
//     const officeMap = stateMap.get(state)!;

//     if (!officeMap.has(officeRep)) officeMap.set(officeRep, []);
//     officeMap.get(officeRep)!.push(rec);
//   }

//   for (const [country, stateMap] of countryMap.entries()) {
//     this.finalData.push({ _isCountryHeader: true, country });

//     for (const [state, officeMap] of stateMap.entries()) {
//       this.finalData.push({ _isStateHeader: true, state });

//       for (const [officeRep, records] of officeMap.entries()) {
//         this.finalData.push({ _isOfficeRepHeader: true, office_rep_name: officeRep });

//         const seenReps = new Set<string>();
//         const officeTotal: any = {
//           _isOfficeTotal: true,
//           office_rep_name: officeRep,
//           'वर्गणी दार संख्या': 0,
//           नवीन: 0,
//           नूतनीकरण: 0,
//           'नूतनी-बाकी': 0,
//           'रक्कम': 0,
//         };

//         this.subTypesName.forEach(sub => {
//           if (sub.isVisible) {
//             const key = this.getKey(sub.name);
//             ['नवीन', 'नूतनीकरण', 'नूतनी-बाकी', 'एकूण'].forEach(suffix => {
//               officeTotal[`${key}_${suffix}`] = 0;
//             });
//           }
//         });

//         for (const record of records) {
//           const repKey = `${record.rep_name}_${record.rep_taluka}`;
//           if (seenReps.has(repKey)) continue;
//           seenReps.add(repKey);

//           const repRecords = records.filter(r => r.rep_name === record.rep_name && r.rep_taluka === record.rep_taluka);

//           const repRow: any = {
//             _isIndividual: true,
//             rep_name: record.rep_name,
//             rep_taluka: record.rep_taluka,
//             district_name: record.district_name,
//               country: record.country,
//               state: record.state,
//             taluka: record.taluka,
//             'वर्गणी दार संख्या': 0,
//             नवीन: 0,
//             नूतनीकरण: 0,
//             'नूतनी-बाकी': 0,
//             'रक्कम': 0,
//           };

//           const repTotal: any = {
//             _isRepTotal: true,
//             rep_name: record.rep_name,
//             'वर्गणी दार संख्या': 0,
//             नवीन: 0,
//             नूतनीकरण: 0,
//             'नूतनी-बाकी': 0,
//             'रक्कम': 0,
//           };

//           this.subTypesName.forEach(sub => {
//             if (sub.isVisible) {
//               const key = this.getKey(sub.name);
//               ['नवीन', 'नूतनीकरण', 'नूतनी-बाकी', 'एकूण'].forEach(suffix => {
//                 repRow[`${key}_${suffix}`] = 0;
//                 repTotal[`${key}_${suffix}`] = 0;
//               });
//             }
//           });

//           repRecords.forEach(subRec => {
//             const amt = parseInt(subRec.total_amt, 10) || 0;
//             const key = this.getKey(subRec.subscription_type);
//             const isVisible = this.subTypesName.some(sub => sub.isVisible && sub.name === subRec.subscription_type);
//             if (!isVisible) return;

//             const isNew = subRec.rcpt_type === 'New';
//             const isRenew = subRec.rcpt_type === 'Renew';
//             const isAmtValid =
//               ((subRec.subscription_type === 'वार्षिक' || subRec.subscription_type === 'रा.स्व.संघ ग्रंथ') && amt === 1000) ||
//               (subRec.subscription_type === 'त्रैवार्षिक' && amt === 2500) ||
//               (subRec.subscription_type === 'पंचवार्षिक' && amt === 4000) ||
//               (subRec.subscription_type === 'राष्ट्रोत्थान 2500' && amt === 2500) ||
//               (subRec.subscription_type === 'राष्ट्रोत्थान 2100' && amt === 2100);

//             if (!isAmtValid) return;

//             const targets = [repRow, repTotal, officeTotal, finalTotal];
//             targets.forEach(obj => {
//               obj['वर्गणी दार संख्या']++;
//               obj['रक्कम'] += amt;
//               obj[`${key}_एकूण`] += amt;
//             });

//             if (isNew) {
//               targets.forEach(obj => {
//                 obj['नवीन']++;
//                 obj[`${key}_नवीन`] = (obj[`${key}_नवीन`] || 0) + 1;
//               });
//             } else if (isRenew) {
//               targets.forEach(obj => {
//                 obj['नूतनीकरण']++;
//                 obj[`${key}_नूतनीकरण`] = (obj[`${key}_नूतनीकरण`] || 0) + 1;
//               });
//             } else {
//               targets.forEach(obj => {
//                 obj['नूतनी-बाकी']++;
//                 obj[`${key}_नूतनी-बाकी`] = (obj[`${key}_नूतनी-बाकी`] || 0) + 1;
//               });
//             }
//           });

//           this.finalData.push(repRow);
//           this.finalData.push(repTotal);
//         }

//         this.finalData.push(officeTotal);
//       }
//     }
//   }

//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }


setData() {
  this.finalData = [];
  this.isLoading = true;

  const finalTotal: any = {
    name: 'एकूण',
    country: '',
    state: '',
    'वर्गणी दार संख्या': 0,
    नवीन: 0,
    नूतनीकरण: 0,
    'नूतनी-बाकी': 0,
    'रक्कम': 0,
  };

  this.subTypesName.forEach(sub => {
    if (sub.isVisible) {
      const key = this.getKey(sub.name);
      ['नवीन', 'नूतनीकरण', 'नूतनी-बाकी', 'एकूण'].forEach(suffix => {
        finalTotal[`${key}_${suffix}`] = 0;
      });
    }
  });

  const countryMap = new Map<string, Map<string, Map<string, any[]>>>();

  for (const rec of this.rojmelData) {
    const country = rec.country || 'UNKNOWN';
    const state = rec.state || 'UNKNOWN';
    const officeRep = rec.office_rep_name || 'UNKNOWN';

    if (!countryMap.has(country)) countryMap.set(country, new Map());
    const stateMap = countryMap.get(country)!;

    if (!stateMap.has(state)) stateMap.set(state, new Map());
    const officeMap = stateMap.get(state)!;

    if (!officeMap.has(officeRep)) officeMap.set(officeRep, []);
    officeMap.get(officeRep)!.push(rec);
  }

  for (const [country, stateMap] of countryMap.entries()) {
    for (const [state, officeMap] of stateMap.entries()) {
      for (const [officeRep, records] of officeMap.entries()) {
        this.finalData.push({
          _isOfficeRepHeader: true,
          office_rep_name: officeRep,
          country,
          state
        });

        const seenReps = new Set<string>();

        const officeTotal: any = {
          _isOfficeTotal: true,
          office_rep_name: officeRep,
          country,
          state,
          'वर्गणी दार संख्या': 0,
          नवीन: 0,
          नूतनीकरण: 0,
          'नूतनी-बाकी': 0,
          'रक्कम': 0,
        };

        this.subTypesName.forEach(sub => {
          if (sub.isVisible) {
            const key = this.getKey(sub.name);
            ['नवीन', 'नूतनीकरण', 'नूतनी-बाकी', 'एकूण'].forEach(suffix => {
              officeTotal[`${key}_${suffix}`] = 0;
            });
          }
        });

        for (const record of records) {
          const repKey = `${record.rep_name}_${record.rep_taluka}`;
          if (seenReps.has(repKey)) continue;
          seenReps.add(repKey);

          const repRecords = records.filter(r => r.rep_name === record.rep_name && r.rep_taluka === record.rep_taluka);

          const repRow: any = {
            _isIndividual: true,
            rep_name: record.rep_name,
            rep_taluka: record.rep_taluka,
            district_name: record.district_name,
            taluka: record.taluka,
            country,
            state,
            'वर्गणी दार संख्या': 0,
            नवीन: 0,
            नूतनीकरण: 0,
            'नूतनी-बाकी': 0,
            'रक्कम': 0,
          };

          const repTotal: any = {
            _isRepTotal: true,
            rep_name: record.rep_name,
            country,
            state,
            'वर्गणी दार संख्या': 0,
            नवीन: 0,
            नूतनीकरण: 0,
            'नूतनी-बाकी': 0,
            'रक्कम': 0,
          };

          this.subTypesName.forEach(sub => {
            if (sub.isVisible) {
              const key = this.getKey(sub.name);
              ['नवीन', 'नूतनीकरण', 'नूतनी-बाकी', 'एकूण'].forEach(suffix => {
                repRow[`${key}_${suffix}`] = 0;
                repTotal[`${key}_${suffix}`] = 0;
              });
            }
          });

          repRecords.forEach(subRec => {
            const amt = parseInt(subRec.total_amt, 10) || 0;
            const key = this.getKey(subRec.subscription_type);
            const isVisible = this.subTypesName.some(sub => sub.isVisible && sub.name === subRec.subscription_type);
            if (!isVisible) return;

            const isNew = subRec.rcpt_type === 'New';
            const isRenew = subRec.rcpt_type === 'Renew';

            const isAmtValid =
              ((subRec.subscription_type === 'वार्षिक' || subRec.subscription_type === 'रा.स्व.संघ ग्रंथ') && amt === 1000) ||
              (subRec.subscription_type === 'त्रैवार्षिक' && amt === 2500) ||
              (subRec.subscription_type === 'पंचवार्षिक' && amt === 4000) ||
              (subRec.subscription_type === 'राष्ट्रोत्थान 2500' && amt === 2500) ||
              (subRec.subscription_type === 'राष्ट्रोत्थान 2100' && amt === 2100);

            if (!isAmtValid) return;

            const targets = [repRow, repTotal, officeTotal, finalTotal];

            targets.forEach(obj => {
              obj['वर्गणी दार संख्या']++;
              obj['रक्कम'] += amt;
              obj[`${key}_एकूण`] += amt;
            });

            if (isNew) {
              targets.forEach(obj => {
                obj['नवीन']++;
                obj[`${key}_नवीन`] = (obj[`${key}_नवीन`] || 0) + 1;
              });
            } else if (isRenew) {
              targets.forEach(obj => {
                obj['नूतनीकरण']++;
                obj[`${key}_नूतनीकरण`] = (obj[`${key}_नूतनीकरण`] || 0) + 1;
              });
            } else {
              targets.forEach(obj => {
                obj['नूतनी-बाकी']++;
                obj[`${key}_नूतनी-बाकी`] = (obj[`${key}_नूतनी-बाकी`] || 0) + 1;
              });
            }
          });

            // Step 4f: Get location data
    if (repRecords.length > 0) {
      this.countryNameNew = repRecords[0].country;
      this.stateNameNew = repRecords[0].state;
    }

          this.finalData.push(repRow);
          this.finalData.push(repTotal);
        }

        this.finalData.push(officeTotal);
      }
    }
  }

  this.finalData.push(finalTotal);
  this.isLoading = false;
}



     getKey(name) {
       return name.replaceAll(' ', '_');
     }
   
     uniqueData(data, key) {
       return [...new Map(data.map((a) => [key(a), a])).values()];
     }
   
     exportExcel(fileName) {
       /* table id is passed over here */
       let element = document.getElementById('print-section');
       const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
   
       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
   
       /* save to file */
       XLSX.writeFile(wb, fileName + '.xlsx');
     }
   
   
      //Main Report Method Use in all Printing Page
     show = false
   

    printPage() {
  this.show = true;
  const printContent = document.getElementById('print-section')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  // const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page {
                size: A3 landscape;
                margin: 10mm;
              }

              body {
                font-family: Arial, sans-serif;
                font-size: 13px;
                margin: 0;
                padding: 5mm;
                line-height: 1.4;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: auto;
                word-wrap: break-word;
              }

              th, td {
                border: 1px solid black;
                padding: 4px 6px;
                text-align: center;
                vertical-align: middle;
                word-break: break-word;
              }

              th {
                background-color: #f2f2f2;
              }

              .noPrint {
                display: none;
              }
            }

            /* Optional: screen preview before print */
            body {
              font-family: Arial, sans-serif;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th, td {
              border: 1px solid black;
              padding: 4px;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div id="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 800);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

   
   }
   